// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./Tooltip";
export type { TooltipProps } from "./Tooltip";
export * from "./Tooltip.styled";
